/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLicenseExtraction = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2v6h12.586l-1.293 1.293 1.414 1.414 3-3 .707-.707-.707-.707-3-3-1.414 1.414L18.586 18H8v-4h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H4zm1 10V4h14v8h-6.035a3.503 3.503 0 0 0-1.84-2.6 2.5 2.5 0 1 0-3.25 0 3.503 3.503 0 0 0-1.84 2.6H5zm5.915 0h-2.83a1.5 1.5 0 0 1 2.83 0zM9.5 7a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1zM17 7h-3V5h3v2zm-3 4h3V9h-3v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgLicenseExtraction as LicenseExtraction };
